import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentError from './AsyncComponentError';
import EmptyComponent from './EmptyComponent';
const AsyncSendTranscriptPrompt = Loadable({
  loader: () => import( /* webpackChunkName: "send-chat-transcript-prompts" */'conversations-thread-view/chat-feed-actions-header/components/SendChatTranscriptPrompt'),
  LoadingComponent: EmptyComponent,
  ErrorComponent: AsyncComponentError
});
export default AsyncSendTranscriptPrompt;